import { render, staticRenderFns } from "./Admission.vue?vue&type=template&id=11d5ea8a&"
import script from "./Admission.vue?vue&type=script&lang=ts&"
export * from "./Admission.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d5ea8a')) {
      api.createRecord('11d5ea8a', component.options)
    } else {
      api.reload('11d5ea8a', component.options)
    }
    module.hot.accept("./Admission.vue?vue&type=template&id=11d5ea8a&", function () {
      api.rerender('11d5ea8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/text/sections/Admission.vue"
export default component.exports